import { h } from '@atomify/jsx';
import { RangeSliderElement, RangeSliderProps } from '@bpd-library/components';
import { RadioElement } from '@source/components/atoms';
import { CheckboxElement } from '@source/components/atoms/form-elements/checkbox/checkbox';
import { FilterInput } from '@source/store/filters';

export interface GeneratedFiltersProps {
    type: string;
    components: Array<FilterInput>;
    rangeSliderOptions?: RangeSliderProps;
}
export const generateInputs = ({ type, components, rangeSliderOptions }: GeneratedFiltersProps) => {
    switch (type) {
        case 'radio':
            const options = components.map(component => ({
                name: component.name,
                label: component.label,
                value: component.value,
                id: component.id,
                checked: component.checked,
            }));
            return options?.length === 0 ? null : (
                <RadioElement classes="property-filter__filter" options={options} />
            );

        case 'checkbox':
            return components.map(component => (
                <CheckboxElement
                    label={component.label}
                    name={component.name}
                    id={component.id}
                    value={component.value}
                    hideError={true}
                    checked={component.checked}
                    classes="property-filter__filter"
                />
            ));

        case 'range':
            if (!rangeSliderOptions) return;
            return <RangeSliderElement classes="property-filter__filter" {...rangeSliderOptions} />;
        default:
            return null;
    }
};
